export default "__VITE_ASSET__9fdd6952__"